module.exports = __webpack_public_path__ + "static/img/team-2.de26a134.jpg";